'use strict';

module.exports = require('./slider');


//////////////////
// WEBPACK FOOTER
// ./~/react-slick/lib/index.js
// module id = 500
// module chunks = 3 4 5 6 7